import { gql } from '@apollo/client';

const Dependencies = gql`
  fragment Dependencies on DependenciesDTO {
  	from
  	to
  	type
  	id
  }
`;

export default Dependencies;
